import { LoadingOverlay } from '@mantine/core'
import { useRouter } from 'next/router'

import { Redirect } from '@/components/commons'

export default function LegacyChannelPage() {
  const router = useRouter()
  const { channel: channelSlug } = router.query || {}
  if (!channelSlug) {
    return <LoadingOverlay visible />
  }
  return <Redirect url={`/${channelSlug.toString().toLowerCase()}`}/>
}
